<template>
  <div class="header">
    <q-input
      ref="input"
      v-model="computedReportName"
      :rules="[required]"
      label="Add report name"
      dense
      no-error-icon
      filled
    />

    <div class="actions">
      <q-btn :disable="disableSaveOrUpdateBtn" size="sm" color="tertiary" @click="saveOrUpdateClicked">
        {{ routerView === 'newReportPage' ? 'Save' : 'Update' }}
      </q-btn>

      <q-btn :readonly="isSaveBtnLoading" size="sm" color="positive" @click="$emit('generate')">
        Generate and email report
      </q-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    isSaveBtnLoading: Boolean,
    reportName: String
  },

  data: () => ({
    required: val => !!val || '* Required'
  }),

  computed: {
    ...mapState('reports', ['newReport', 'reportToEdit', 'routerView']),

    ...mapGetters('reports', ['isReportUpdated']),

    computedReportName: {
      get() {
        return this.reportName
      },
      set(val) {
        this.$emit('update:reportName', val)
      }
    },

    disableSaveOrUpdateBtn() {
      if (this.routerView === 'newReportPage') return false
      return !this.isReportUpdated
    }
  },

  methods: {
    saveOrUpdateClicked() {
      if (!this.reportName) {
        this.$refs.input.validate()
        return
      }
      if (this.routerView === 'newReportPage') this.$emit('save')
      else this.$emit('update')
    }
  }
}
</script>

<style lang="stylus" scoped>
.header {
  display grid
  grid-template-columns auto 1fr
  align-items center
  justify-content start
  padding 15px
  gap 10px

  .actions {
    display grid
    grid-auto-flow column
    justify-content end
    gap 10px
  }
}
</style>
